export default "__VITE_ASSET__CRPOfPRB__"